import { useEffect } from 'react';

import { Camera, PerspectiveCamera } from 'three';

type OffsetCamera = Camera & {
    manual?: boolean;
};

type UseViewOffsetParams = {
    camera: OffsetCamera;
    canvas: HTMLElement;
    horizontalOffset: number;
    verticalOffset: number;
};
// Apply horizontal/vertical offset using view offset (shifts the camera frustum)
export function useViewOffset({ camera, canvas, horizontalOffset, verticalOffset }: UseViewOffsetParams) {
    useEffect(() => {
        const perspectiveCamera = camera as PerspectiveCamera;
        if (horizontalOffset !== 0 || verticalOffset !== 0) {
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            // Offset is a fraction; positive horizontal shifts view right (subject appears left)
            // Positive vertical shifts view down (subject appears up)
            const offsetX = horizontalOffset * width;
            const offsetY = verticalOffset * height;
            perspectiveCamera.setViewOffset(width, height, offsetX, offsetY, width, height);
        } else {
            perspectiveCamera.clearViewOffset();
        }
    }, [camera, canvas, horizontalOffset, verticalOffset]);
}
